import _extends from "@babel/runtime/helpers/esm/extends";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { createElement } from "@wordpress/element";

/** @format */

/**
 * External dependencies
 */
import { __ } from '@wordpress/i18n';
import { Component, Fragment } from '@wordpress/element';
import { find } from 'lodash';
import PropTypes from 'prop-types';
/**
 * WooCommerce dependencies
 */

import { updateQueryString } from '@woocommerce/navigation';
/**
 * Internal dependencies
 */

import AdvancedFilters from '../advanced-filters';
import { CompareFilter } from '../compare-filter';
import DateRangeFilterPicker from '../date-range-filter-picker';
import FilterPicker from '../filter-picker';
import { H, Section } from '../section';
/**
 * Add a collection of report filters to a page. This uses `DatePicker` & `FilterPicker` for the "basic" filters, and `AdvancedFilters`
 * or a comparison card if "advanced" or "compare" are picked from `FilterPicker`.
 *
 * @return { object } -
 */

var ReportFilters =
/*#__PURE__*/
function (_Component) {
  _inherits(ReportFilters, _Component);

  function ReportFilters() {
    var _this;

    _classCallCheck(this, ReportFilters);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReportFilters).call(this));
    _this.renderCard = _this.renderCard.bind(_assertThisInitialized(_this));
    _this.onRangeSelect = _this.onRangeSelect.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(ReportFilters, [{
    key: "renderCard",
    value: function renderCard(config) {
      var _this$props = this.props,
          siteLocale = _this$props.siteLocale,
          advancedFilters = _this$props.advancedFilters,
          query = _this$props.query,
          path = _this$props.path,
          onAdvancedFilterAction = _this$props.onAdvancedFilterAction,
          currency = _this$props.currency;
      var filters = config.filters,
          param = config.param;

      if (!query[param]) {
        return null;
      }

      if (0 === query[param].indexOf('compare')) {
        var filter = find(filters, {
          value: query[param]
        });

        if (!filter) {
          return null;
        }

        var _filter$settings = filter.settings,
            settings = _filter$settings === void 0 ? {} : _filter$settings;
        return createElement("div", {
          key: param,
          className: "woocommerce-filters__advanced-filters"
        }, createElement(CompareFilter, _extends({
          path: path,
          query: query
        }, settings)));
      }

      if ('advanced' === query[param]) {
        return createElement("div", {
          key: param,
          className: "woocommerce-filters__advanced-filters"
        }, createElement(AdvancedFilters, {
          siteLocale: siteLocale,
          currency: currency,
          config: advancedFilters,
          path: path,
          query: query,
          onAdvancedFilterAction: onAdvancedFilterAction
        }));
      }
    }
  }, {
    key: "onRangeSelect",
    value: function onRangeSelect(data) {
      var _this$props2 = this.props,
          query = _this$props2.query,
          path = _this$props2.path,
          onDateSelect = _this$props2.onDateSelect;
      updateQueryString(data, path, query);
      onDateSelect(data);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          dateQuery = _this$props3.dateQuery,
          filters = _this$props3.filters,
          query = _this$props3.query,
          path = _this$props3.path,
          showDatePicker = _this$props3.showDatePicker,
          onFilterSelect = _this$props3.onFilterSelect,
          isoDateFormat = _this$props3.isoDateFormat;
      return createElement(Fragment, null, createElement(H, {
        className: "screen-reader-text"
      }, __('Filters', 'woocommerce-admin')), createElement(Section, {
        component: "div",
        className: "woocommerce-filters"
      }, createElement("div", {
        className: "woocommerce-filters__basic-filters"
      }, showDatePicker && createElement(DateRangeFilterPicker, {
        key: JSON.stringify(query),
        dateQuery: dateQuery,
        onRangeSelect: this.onRangeSelect,
        isoDateFormat: isoDateFormat
      }), filters.map(function (config) {
        if (config.showFilters(query)) {
          return createElement(FilterPicker, {
            key: config.param,
            config: config,
            query: query,
            path: path,
            onFilterSelect: onFilterSelect
          });
        }
      })), filters.map(this.renderCard)));
    }
  }]);

  return ReportFilters;
}(Component);

ReportFilters.propTypes = {
  /**
   * The locale of the site (passed through to `AdvancedFilters`)
   */
  siteLocale: PropTypes.string,

  /**
   * Config option passed through to `AdvancedFilters`
   */
  advancedFilters: PropTypes.object,

  /**
   * Config option passed through to `FilterPicker` - if not used, `FilterPicker` is not displayed.
   */
  filters: PropTypes.array,

  /**
   * The `path` parameter supplied by React-Router
   */
  path: PropTypes.string.isRequired,

  /**
   * The query string represented in object form
   */
  query: PropTypes.object,

  /**
   * Whether the date picker must be shown.
   */
  showDatePicker: PropTypes.bool,

  /**
   * Function to be called after date selection.
   */
  onDateSelect: PropTypes.func,

  /**
   * Function to be called after filter selection.
   */
  onFilterSelect: PropTypes.func,

  /**
   * Function to be called after an advanced filter action has been taken.
   */
  onAdvancedFilterAction: PropTypes.func,

  /**
   * The currency formatting instance for the site.
   */
  currency: PropTypes.object.isRequired,

  /**
   * The date query string represented in object form.
   */
  dateQuery: PropTypes.shape({
    period: PropTypes.string.isRequired,
    compare: PropTypes.string.isRequired,
    before: PropTypes.object,
    after: PropTypes.object,
    primaryDate: PropTypes.shape({
      label: PropTypes.string.isRequired,
      range: PropTypes.string.isRequired
    }).isRequired,
    secondaryDate: PropTypes.shape({
      label: PropTypes.string.isRequired,
      range: PropTypes.string.isRequired
    }).isRequired
  }).isRequired,

  /**
   * ISO date format string.
   */
  isoDateFormat: PropTypes.string.isRequired
};
ReportFilters.defaultProps = {
  siteLocale: 'en_US',
  advancedFilters: {},
  filters: [],
  query: {},
  showDatePicker: true,
  onDateSelect: function onDateSelect() {}
};
export default ReportFilters;
//# sourceMappingURL=index.js.map